import { render, staticRenderFns } from "./CustomCheckboxSingleOption.vue?vue&type=template&id=8ed1b390&scoped=true"
import script from "./CustomCheckboxSingleOption.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxSingleOption.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckboxSingleOption.vue?vue&type=style&index=0&id=8ed1b390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed1b390",
  null
  
)

export default component.exports